import { startCase } from 'lodash-es';
import type { FinpspTransactionReport, Withdrawal } from '../@types/api';
import { PAYMENT_GATEWAY } from '../constants/enums';
import { FINPSP_METHOD_LABELS, FINPSP_STATE } from '../constants/finpsp';
import { getApprovalStatusColor, formatSnakeCaseString } from '../utils';
import { getZeroXStatusNotice, WITHDRAWAL_STATE_LABELS } from './zeroXWithdrawalDisplay';
import { getFinpspStatusLabel } from './finpsp';

type PaymentMetadata = { finpsp?: FinpspTransactionReport };

export const formatPaymentMethod = (method: string, metadata?: PaymentMetadata | null) => {
  const facts = metadata?.finpsp;

  return facts?.gateway === PAYMENT_GATEWAY.FINPSP
    ? (FINPSP_METHOD_LABELS[facts.bankType] ?? formatSnakeCaseString(method, false))
    : formatSnakeCaseString(method, false);
};

export const getWithdrawalDisplay = (withdrawal: Withdrawal) => {
  const { finpsp, cryptoWithdrawal, status } = withdrawal;

  if (finpsp) {
    let statusTone = 'info.main';
    switch (finpsp.state) {
      case FINPSP_STATE.CREATED:
      case FINPSP_STATE.AWAITING_APPROVAL:
      case FINPSP_STATE.SUBMISSION_UNKNOWN:
      case FINPSP_STATE.REVIEW:
        statusTone = 'warning.main';
        break;
      case FINPSP_STATE.APPROVED:
        statusTone = 'success.main';
        break;
      case FINPSP_STATE.REJECTED:
        statusTone = 'error.main';
        break;
      case FINPSP_STATE.SUBMITTING:
      case FINPSP_STATE.PENDING:
        break;
      default:
        statusTone = 'warning.main';
    }

    return { statusLabel: getFinpspStatusLabel(finpsp), statusTone, notice: null };
  }

  return {
    statusLabel: cryptoWithdrawal ? WITHDRAWAL_STATE_LABELS[cryptoWithdrawal.state] : startCase(status),
    statusTone: getApprovalStatusColor(status),
    notice: getZeroXStatusNotice(cryptoWithdrawal),
  };
};
